import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '🤖',
      title: 'Inteligencia Artificial',
      description: 'Desarrollamos soluciones con IA generativa ajustadas a las necesidades de cada negocio, utilizando modelos avanzados como OpenAI GPT, LLaMA, Claude y Gemini.',
      color: 'purple'
    },
    {
      icon: '📊',
      title: 'Analítica y Ciencia de Datos',
      description: 'Diseñamos modelos de analítica y machine learning integrados a los procesos y datos de cada cliente, visualizables a través de Dashboards personalizados.',
      color: 'orange'
    },
    {
      icon: '💻',
      title: 'Fábrica de Software',
      description: 'Desarrollamos aplicaciones web, móviles y multiplataforma enfocadas 100% en la experiencia de los usuarios, personalizadas, seguras y alineadas con los objetivos de negocio.',
      color: 'purple'
    },
    {
      icon: '🔄',
      title: 'Transformación Digital',
      description: 'Te acompañamos y ayudamos a modernizar tus procesos con tecnologías avanzadas para mejorar la experiencia del cliente y aumentar tu competitividad.',
      color: 'orange'
    },
    {
      icon: '⚙️',
      title: 'Automatización de Procesos (RPA)',
      description: 'Implementamos soluciones de RPA que se integran de forma ágil con los sistemas existentes, automatizando tareas administrativas y operativas.',
      color: 'purple'
    },
    {
      icon: '🎨',
      title: 'Diseño y Capacitaciones',
      description: 'Nuestros proyectos integran diseño gráfico, UI/UX y estándares de usabilidad. Adicionalmente ofrecemos capacitaciones adaptadas a tus necesidades.',
      color: 'orange'
    }
  ];

  return (
    <section id="servicios" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Servicios</h2>
          <p className="section-subtitle">
            Soluciones integrales para impulsar tu transformación digital
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card service-${service.color}`}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

